import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, List, ListItemButton, Grid, ListItemIcon, ListItemText, Typography, IconButton } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import WorkIcon from '@mui/icons-material/Work';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SchoolIcon from '@mui/icons-material/School';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import InfoIcon from '@mui/icons-material/Info';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Edit } from "@mui/icons-material";
import avatar from "../../../../../../assets/profile.webp";
import { LearnersProfile } from "../../../../../../helper/base_url";

const menuItems = [
  { label: 'Resume', icon: <DescriptionIcon /> },
  { label: 'Personal Details', icon: <PersonIcon /> },
  { label: 'Career Profile', icon: <WorkIcon /> },
  { label: 'Experience', icon: <BusinessCenterIcon /> },
  { label: 'Highest Education', icon: <SchoolIcon /> },
  { label: 'Projects', icon: <AssignmentIcon /> },
  { label: 'Additional Information', icon: <InfoIcon /> },
];

const SidebarMenu = () => {  
  const [data, setData] = useState({
    profilePic: "",
  });

  // Scroll to the selected section
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  // Fetch profile picture on component load
  useEffect(() => {
    const fetchProfilePic = async () => {
      try {
        const res = await axios.get(`${LearnersProfile}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (res.data?.data?.profileImageUrl) {
          setData((prevData) => ({ ...prevData, profilePic: res.data.data.profileImageUrl }));
        }
      } catch (err) {
        console.error('Error fetching profile picture:', err);
      }
    };
    fetchProfilePic();
  }, []);

  // Upload profile picture to backend
  const onUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      const res = await axios.put(`${LearnersProfile}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (res.data?.data?.image) {
        setData((prevData) => ({ ...prevData, profilePic: res.data.data.image }));
      }
    } catch (err) {
      console.error('Error uploading profile picture:', err);
    }
  };

  return (
    <Box
      sx={{
        width : '100%',
        bgcolor: '#ffffff',
        borderRadius: 3,
        boxShadow: 3,
        padding: '10px',
        position: 'sticky',
        top : 20,
        height : 'fit-content',
      }}
    >
      <Grid item xs={12} textAlign="center">
        <label htmlFor="profile-upload" style={{ position: 'relative', display: 'inline-block' }}>
          <img
            src={data.profilePic || avatar}
            alt="Profile"
            style={{ width : 120, height : 120, borderRadius: '50%', cursor: 'pointer' }}
          />
          <Edit
            style={{
              position: 'absolute',
              bottom : 5,
              right : 5,
              backgroundColor: '#fff',
              borderRadius: '50%',
              padding: 4,
              fontSize: 35,
              cursor: 'pointer',
            }}
          />
        </label>
        <input
          type="file"
          id="profile-upload"
          name="profile"
          onChange={onUpload}
          style={{ display: 'none' }}
        />
      </Grid>

      <List>
        {menuItems.map((item, idx) => (
          <ListItemButton
            key={idx}
            onClick={() => scrollToSection(item.label.replace(/\s+/g, ''))}
            sx={{
              borderRadius: 2,
              transition: '0.3s',
              '&:hover': {
                bgcolor: '#e3f2fd',
                transform: 'scale(1.02)',
              },
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListItemIcon sx={{ minWidth : 24, color: '#043885', mr: 1 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography sx={{ fontWeight: 500, fontSize: '15px' }}>
                    {item.label}
                  </Typography>
                }
              />
            </Box>
            <IconButton edge="end" size="small" sx={{ color: '#043885' }}>
              <EditNoteIcon fontSize="small" />
            </IconButton>
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default SidebarMenu;
